module.exports = __webpack_public_path__ + "img/NXT_ny_logo_ingen_Payoff.a94f82eb.png";